/* script */
//
//
//
//
//
//
//

import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';
import RejectModal from 'ui/components/meetings/meeting-requests/RejectModal.vue';

const __vue_script__ = {
    name: 'CustomBulkActions',
    props: {
        event: {
            type: Object,
            required: true
        },

        selectedItems: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        showRequestAvailabilityButton() {
            return this.selectedItems?.every(({ status }) => status === 'draft');
        },
        showRejectButton() {
            return this.selectedItems?.every(({ status }) => status === 'awaiting' || status === 'ready');
        }
    },

    methods: {
        /**
         * Confirmation modal of bulk meeting request availability request sending
         */
        openModalRequestAvailability() {
            this.$modal.show(DialogComponent, {
                title: this.$t('meetings.requests.dialog.request-availability.title'),
                text: this.$t('meetings.requests.dialog.request-availability.text'),
                buttons: [{
                    title: this.$t('general.cancel'),
                    handler: () => this.$modal.hide('meeting-request-availability'),
                    class: 'btn'
                }, {
                    title: this.$t('meetings.requests.dialog.request-availability.send'),
                    default: true,
                    handler: async () => {
                        if (this.loading) {
                            return;
                        }
                        this.loading = true;

                        await this.sendAvailabilityEmails();

                        this.$modal.hide('meeting-request-availability');
                        this.loading = false;
                    },
                    class: 'btn btn-primary'
                }],
            }, {
                name: 'meeting-request-availability',
                classes: 'small',
                reset: true,
                height: 'auto'
            });
        },

        /**
         * Confirmation modal of bulk meeting request rejection
         */
        openModalReject() {
            this.$modal.show(RejectModal, {
                ids: this.selectedItems.map(({ _id }) => _id),
                event: this.event,
                onClose: () => {
                    this.$modal.hide('meeting-request-reject');
                    this.$emit('reload');
                }
            }, {
                name: 'meeting-request-reject',
                classes: 'small',
                reset: true,
                height: 'auto'
            });
        },

        /**
         * Send availability emails handler
         * Calls related app script to send availability emails
         * to participants of the meeting requests
         */
        async sendAvailabilityEmails() {
            try {
                const ids = this.selectedItems?.map(({ _id }) => _id);
                if (!ids?.length) {
                    console.warn('[BulkActions] No selected items to sendAvailabilityEmails');
                    return;
                }
                await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'meeting-requests/request-availability',
                    { ids }
                );
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.notify.availability_request_sent_success').toString(),
                });
                this.$emit('reload');
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.notify.availability_request_sent_fail').toString(),
                    type: 'error'
                });
            }
        },


    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-bulk-actions" }, [
    _vm.showRequestAvailabilityButton
      ? _c(
          "button",
          {
            staticClass: "btn primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.openModalRequestAvailability()
              },
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("meetings.requests.actions.request-availability"))
            ),
          ]
        )
      : _vm._e(),
    _vm.showRejectButton
      ? _c(
          "button",
          {
            staticClass: "btn danger",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.openModalReject()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("meetings.requests.actions.reject-request")))]
        )
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/CustomBulkActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__